
import store from '../store'
import http from './http'
import storage from '../utils/storage';
import roles from './roles';

export default {
  user: {
    authenticated: false
  },
  login (app, user) {
    this.logout();
    app.$http
      .post('auth/adminlogin', {
        email: user.email,
        password: user.password
      })
      .then(response => {
        console.log('login response', response.data)
        if (response.data.auth) {

          storage.save('token', response.data.token, 1000)
          console.log('------------ token is: ', response.data.token);
          store.dispatch('setUser', response.data.user);
          console.log('login', response.data.user);
          store.dispatch('setMenu', response.data.user);
          app.$bus.$emit('login');

          if (response.data.msg === 'change pass') {
            console.log('change your password x')
            if (app.$route.query.redirect) {
              return app.$router.push({name: 'changepass', query: { redirect: app.$route.query.redirect }})
            } else {
              console.log('go changepass')
              return app.$router.push({name: 'changepass'})
            }
          }

          if (app.$route.query.redirect) {
            app.$router.push(app.$route.query.redirect)
          } else {
            app.$router.push('/')
          }
        } else {
          console.log('login 2 failed')
        }
      })
      .catch(function (error) {
        console.log('catch:', error.response)
      })
  },
  logout () {
    store.dispatch('removeUser');
    store.dispatch('removeMenu');
  },
  changepass (app, user) {
    console.log('auth changepass')
    app.$http
      .post('auth/password', {
        id: user.id,
        email: user.email,
        oldpassword: user.oldpassword,
        newpassword: user.newpassword
      })
      .then(response => {
        console.log('changepass then', response.data)
        if (response.data.auth) {
          console.log('changepass done')
          if (app.$route.query.redirect) {
            app.$router.push(app.$route.query.redirect)
          } else {
            app.$router.push('/')
          }
        } else {
          console.log('changepass failed')
        }
      })
      .catch(function (error) {
        console.log('catch x:', error)
      })
  },
  resetpass (app, user, cb) {
    console.log('auth resetpass')
    app.$http
      .post('auth/resetpass', {
        id: user.id,
        email: user.email
      })
      .then(response => {
        console.log('resetpass then', response.data)
        if (response.data.msg === 'ok') {
          console.log('resetpass done')
          cb(response.data.msg);
        } else {
          console.log('resetpass failed');
          cb(null);
        }
      })
      .catch(function (error) {
        console.log('catch x:', error)
      })
  },
  checkAuth (path) {
    var jwt = storage.load('token');
    // console.log('checkAuth: ', storage.load('muser'));
    var user = storage.load('muser') || {};
    if (jwt && roles.can(user.role, path)) {
      user.authenticated = true;
    } else {
      user.authenticated = false;
    }
    http.instance();

    store.dispatch('setUser', user);

    return user.authenticated
  },
  getAuthHeader () {
    const token = storage.load('token');
    return {
      'Authorization': `Bearer ${token}`
    }
  },
  getToken () {
    var token = storage.load('token');
    // console.log('getToken:', token)
    return `Bearer ${token}`
    //return token
  },
  getUser: {
    get () {
      return storage.load('muser');
    }
  }
}
